import { NavLink, generatePath, useParams } from 'react-router-dom';
import {
  SidePanel,
  SidePanelType,
  ButtonPrimary,
  ButtonPseudo,
  formatDate,
  ApplicationSelector,
} from '@ui/src';
import SelectCompanyOfficialForm from '../../../../components/corporate/overview/select-company-official-form';
import useSelectCompanyOfficial from '../hooks/use-select-company-official';

import ROUTES from '../../../../routes';

import cn from '../styles.module.css';

const SelectCompanyOfficial = () => {
  const { customerId } = useParams();

  const {
    selectedCustomerId,
    autocompleteList,
    panelIsOpen,
    handleClose,
    isLoading,
    cofIsLoading,
    addNewCofAction,
    formValues,
    onSearch,
    autocompleteIsLoading,
    cofError,
    setSelectedCustomerId,
    setFormValues,
    searchQuery,
    setSearchQuery,
    getAutocompleteListAction,
    percentageError,
    errors,
  } = useSelectCompanyOfficial({ customerId });

  let link = '';
  let linkText = '';

  if (selectedCustomerId) {
    const currentApplication = autocompleteList.find(
      (item) => item.id === selectedCustomerId,
    );

    if (currentApplication) {
      if (currentApplication.organizationId) {
        link = generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_PAGE, {
          customerId: currentApplication.organizationId,
        });

        linkText = 'Go to customer';
      } else {
        linkText = 'Go to application';

        if (currentApplication.type === 'COMPANY_OFFICIAL') {
          link = generatePath(
            ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL,
            {
              applicationId: selectedCustomerId,
            },
          );
        } else if (currentApplication.type === 'INDIVIDUAL') {
          link = generatePath(
            ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO,
            {
              applicationId: selectedCustomerId,
            },
          );
        }
      }
    }
  }

  return (
    <SidePanel
      type={SidePanelType.Customers}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      title="Add Company official application"
      sidepanelExpandedKey="corporate-create-cof"
      footer={
        <>
          <ButtonPrimary
            text={isLoading || cofIsLoading ? 'Loading...' : 'Add'}
            className={cn.addNewCofButton}
            onClick={addNewCofAction}
            disabled={
              !selectedCustomerId ||
              !formValues?.position ||
              !formValues.signatureType ||
              isLoading ||
              cofIsLoading
            }
            bold
          />
          <ButtonPseudo text="Close" onClick={handleClose} bold />
        </>
      }
    >
      <>
        <div className={cn.selectCompanyOfficialTitle}>
          Select a customer to be appointed as an company official
        </div>
        <div className={cn.selectCompanyOfficialWrapper}>
          <div className={cn.companyOfficialAutocomplete}>
            <ApplicationSelector
              placeholder="Select customer..."
              list={autocompleteList.map((item) => ({
                ...item,
                dob: formatDate(item?.dob || '') || '-',
              }))}
              onSearch={onSearch}
              isLoading={autocompleteIsLoading}
              error={cofError}
              onApplicationClick={(id: string) => {
                const currentCustomer = autocompleteList?.find(
                  (item) => item.id === id,
                );
                setSelectedCustomerId(id);

                if (currentCustomer) {
                  setFormValues({
                    firstName: currentCustomer?.firstName || '',
                    lastName: currentCustomer?.lastName || '',
                    dob: currentCustomer?.dob || '',
                    phone: currentCustomer?.phone,
                    email: currentCustomer?.email as string,
                  });
                }

                if (searchQuery) {
                  setSearchQuery('');
                  getAutocompleteListAction('');
                }
              }}
              onButtonClick={() => {}}
              searchQuery={searchQuery}
              fullWidth
              withoutButton
              withClearButton
            />
          </div>
          {selectedCustomerId && (
            <NavLink
              to={link}
              className={`${cn.customerLink} ${
                !formValues ? cn.customerLinkDisabled : ''
              }`}
              target="_blank"
            >
              {linkText}
            </NavLink>
          )}
        </div>
        <div className={cn.companyOfficialFormContent}>
          <SelectCompanyOfficialForm
            customer={formValues}
            havingControl={formValues?.havingControl}
            percentageError={percentageError}
            setFormValues={setFormValues}
            customerId={selectedCustomerId}
            errors={errors}
          />
        </div>
      </>
    </SidePanel>
  );
};

export default SelectCompanyOfficial;
